module.exports = __webpack_public_path__ + "img/VXVERIFIED.97803738.png";